var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.971895 6.0007L8 2.00121L15.0281 6.00069C15.4161 5.98824 15.7634 5.75368 15.9178 5.39686C16.1372 4.88964 15.9022 4.30132 15.3929 4.08281L8.39718 0.0815988C8.14357 -0.0271996 7.85617 -0.0271996 7.60257 0.0815988L0.606879 4.08281C0.238586 4.24081 0 4.60186 0 5.00121C0 5.54273 0.432243 5.98372 0.971895 6.0007Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.72708L1.5 7.42605V15C1.5 15.5523 1.94772 16 2.5 16H6V11C6 10.4477 6.44772 10 7 10H9C9.55229 10 10 10.4477 10 11V16H13.5C14.0523 16 14.5 15.5523 14.5 15V7.42605L8 3.72708Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4e35eba9ad3b9348867143a20666d39b.svg";
export { ForwardRef as ReactComponent };